export const navigationVars = {
  desktopHeight: '11.2rem',
  desktopWithNotificationHeight: 'calc(18rem + 34px)',
  mobileHeight: '6.2rem',
  mobileWithNotificationHeight: 'calc(13rem + 34px)',
}
